import "./SelectTargetBoard.scss";

import { Box, Flex, Heading } from "monday-ui-react-core";
import React from "react";
import styled from "styled-components";

import { QuickSearch } from "@/components/QuickSearch/QuickSearch";

import iconTwo from "../../../../assets/icons/group-707.svg";

const SelectTargetWrapper = styled.div`
  box-sizing: border-box;
  padding-top: 0;
  padding-left: var(--spacing-medium);
  padding-right: var(--spacing-medium);
  width: 100%;
`;

const StyledBox = styled(Box)`
  overflow: visible;
`;

interface SelectTargetBoardProps {
  onBoardChange: (boardId: string) => void;
  clearValue: boolean;
}

export function SelectTargetBoard({ onBoardChange, clearValue }: SelectTargetBoardProps) {
  return (
    <SelectTargetWrapper>
      <StyledBox
        border={Box.borders.DEFAULT}
        rounded={Box.roundeds.SMALL}
        paddingX={Box.paddingXs.SMALL}
        paddingY={Box.paddingYs.SMALL}
      >
        <Flex
          direction={Flex.directions.COLUMN}
          align={Flex.align.START}
          gap={Flex.gaps.SMALL}
          style={{ padding: "8px" }}
        >
          <Flex direction={Flex.directions.ROW} style={{ height: "30px" }}>
            <img src={iconTwo} alt="Choose target board" />
            <Heading type={Heading.types.h5} value="Choose target board" />
          </Flex>
          <QuickSearch onBoardChange={onBoardChange} clearValue={clearValue} />
        </Flex>
      </StyledBox>
    </SelectTargetWrapper>
  );
}
